import React from 'react';
import { StyleSheet, View, Text } from './components/base_components';
import ProgressSpinner from './components/progress_spinner';
import SelectButton from './components/buttons/select_button';
import StandardBoxList from './components/standard_box_list';
import LinkText from './components/buttons/link_text';

import DeviceStore from './stores/device_store';
import UserStore from './stores/user_store';

import { relativeDate } from './tools/util';

const MAC_NAME = `Mac Apple Silicon ${process.env.MAC_VER}`;
const MAC_URL = `https://maxlo.app/maxlo-client-releases/maxlo-client-darwin-arm64-${process.env.MAC_VER}.zip`;
const MAC_X64_NAME = `Mac Intel x64 ${process.env.MAC_X64_VER}`;
const MAC_X64_URL = `https://maxlo.app/maxlo-client-releases/maxlo-client-darwin-x64-${process.env.MAC_X64_VER}.zip`;
const AVID_LAUNCHER_NAME = `Avid Launcher ${process.env.AVID_LAUNCHER_VER}`;
const AVID_LAUNCHER_URL = `https://maxlo.app/maxlo-client-releases/avid-launcher-${process.env.AVID_LAUNCHER_VER}.zip`;

const SHOW_OPTS = [
  { value: 'active', text: 'Active' },
  { value: 'all', text: 'All' },
];

const styles = StyleSheet.create({
  deviceListScreen: {
    backgroundColor: 'transparent',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  dialog: {
    marginLeft: '2rem',
    marginBottom: '2rem',
    flexDirection: 'column',
  },
  text: {
    marginTop: '1.5rem',
    fontSize: '1.5rem',
  },
  link: {
    alignSelf: 'flex-start',
    marginTop: '1.5rem',
    fontSize: '1.5rem',
  },
  spacer: {
    flex: 1,
  },
});

export default function DeviceList(props) {
  const org = UserStore.useOrg();
  const device_list = DeviceStore.useList(org?.org_id);
  const [show_mode, setShowMode] = React.useState('active');
  React.useEffect(() => {
    DeviceStore.fetch(org?.org_id);
  }, [org?.org_id]);

  let content: any = null;
  let headers: any;
  let list: any[] = [];
  if (!device_list) {
    content = <ProgressSpinner />;
  } else if (device_list?.length > 0) {
    headers = ['Device Name', 'User', 'Status', 'Last Seen', 'Version'];
    list = device_list
      .filter(
        (d) =>
          (show_mode === 'all' || !d.is_disabled) && d.org_id === org?.org_id
      )
      .sort(_sortDevice);
  } else {
    content = (
      <View style={styles.dialog}>
        <Text style={styles.text}>
          Looks like you don't have any devices yet.
        </Text>
        <Text style={styles.text}>
          Download the Maxlo Client to get started!
        </Text>
      </View>
    );
  }
  const buttons = (
    <>
      <SelectButton
        style={props.style}
        options={SHOW_OPTS}
        value={show_mode}
        onChange={setShowMode}
      />
      <View style={styles.spacer} />
    </>
  );

  return (
    <View style={styles.deviceListScreen}>
      <StandardBoxList
        title='Devices'
        detail={list?.length}
        headers={headers}
        sizes={[2, 2, 1, 1, 1]}
        buttons={buttons}
        rows={list?.map?.((device: any) => ({
          url: '/device/' + device?.device_id,
          list: [
            device.device_name,
            device.user_name ?? '',
            device.is_disabled ? 'Disabled' : 'Active',
            relativeDate(device.last_seen) || '-',
            device.last_version || '-',
          ],
        }))}
      >
        {content}
      </StandardBoxList>
      <StandardBoxList title='Maxlo Client'>
        <View style={styles.dialog}>
          <Text style={styles.text}>
            Download the client for your operating system.
          </Text>
          <LinkText style={styles.link} url={MAC_URL} text={MAC_NAME} />
          <LinkText style={styles.link} url={MAC_X64_URL} text={MAC_X64_NAME} />
          <LinkText
            style={styles.link}
            url={AVID_LAUNCHER_URL}
            text={AVID_LAUNCHER_NAME}
          />
        </View>
      </StandardBoxList>
    </View>
  );
}
function _sortDevice(a, b) {
  let ret;
  if (a.is_disabled && !b.is_disabled) {
    ret = 1;
  } else if (a.is_disabled !== b.is_disabled) {
    ret = -1;
  } else {
    ret = a.device_name.localeCompare(b.device_name, undefined, {
      sensitivity: 'base',
    });
  }
  return ret;
}
